import { AdStandard, AdStandardProps } from '../../components/ad/ad-standard'
import { StandardGroupAdBlock } from './standard-group-ad.block'

export const StandardGroupAdComponent = (block: StandardGroupAdBlock) => {
  const componentProps: AdStandardProps = {
    id: block.id,
    title: block.title,
    description: block.description,
    ctaLabel: block.linkText,
    href: block.link,
    imageRatio: block.imageRatio as AdStandardProps['imageRatio'],
    image: block.image,
  }

  return <AdStandard {...componentProps} />
}
